import Vue from "vue";
import App from "./App.vue";

/* 引入组件 */
import router from "@/common/router";
import ElementUI from "element-ui";

/* 引入基础设施 */
import utils from "@/common/infrastructure/utils";

/* 引入样式*/
import "element-ui/lib/theme-chalk/index.css";

/* 主方法 */
Vue.config.productionTip = false;

// 注册 Element组件
Vue.use(ElementUI);

// 初始化 字体大小
utils.computeFontSize();

// 注入 工具
Vue.prototype.$utils = utils;

// 简单的全局配置
Vue.prototype.$appConfig = {
  appName: "公司官网",
  version: "1.0.0",
};

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
